var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-row flex-md-column",attrs:{"id":"modal-navigation-container"}},_vm._l((_vm.items),function(item,index){return _c('a',{class:['dot mx-2 mx-md-0', _vm.currentIndex === index && 'active'],attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('change', index)}}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-232ce05e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationModal.vue
// module id = 517
// module chunks = 1